import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ScrollText } from "lucide-react";
import { PlaceholderPage } from "@/components/vroom/placeholder-page";
import type { RoleKind } from "@/components/vroom/role-pill";

interface SessionUser {
  name: string;
  email: string;
  role?: RoleKind;
}

export const Route = createFileRoute("/_authed/admin/audit-log")({
  beforeLoad: ({ context }) => {
    const user = (context as { user?: { role?: string } }).user;
    if (user?.role !== "super_admin") throw redirect({ to: "/dashboard" });
  },
  component: AuditLogAdmin,
});

function AuditLogAdmin() {
  const { t } = useTranslation();
  const { user } = Route.useRouteContext() as { user: SessionUser };
  return (
    <PlaceholderPage
      user={{ name: user.name, role: "super_admin" }}
      section="admin"
      activeKey="audit-log"
      breadcrumb={<>{t("admin.audit-log.breadcrumb")}</>}
      title={t("admin.audit-log.title")}
      icon={<ScrollText size={48} />}
    />
  );
}
